import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'form-group-upload-box-multiple',
  templateUrl: './form-group-upload-box-multiple.component.html',
  styleUrls: ['./form-group-upload-box-multiple.component.css']
})
export class FormGroupUploadBoxMultipleComponent implements OnInit {

  @Input() formArray: UntypedFormArray;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Input() type: string = '';
  @Input() popoverContent: string = '';
  @Input() modalName: string = '';
  @Input() modalText: string = '';
  @Input() limitFiles: number = 10;

  @ViewChild('inputFile', { static: false }) inputFile: ElementRef;

  public dataArrayFiles: Array<{ file?: File, path?: string, inProgress: boolean }> = [];
  public format: string = '';

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {

    switch (this.type) {

      case 'inputEmployerProfile':
        this.format = ".jpg, jpeg, .png";
        break;
    }
  }

  loadInitialData() {
    this.dataArrayFiles = [];
    this.formArray.value.forEach(element => {
      this.dataArrayFiles.push({ path: element, inProgress: false });
    });
  }

  onClickPseudoBtn(event: PointerEvent): void {
    event.preventDefault();
    $(`#${this.id}`).click();
  }

  onSelectFile(event) {
 

    const fl: FileList = event.target.files;

    const arr = Array.from(fl);

    for (let index = 0; index < arr.length; index++) {
      const e = arr[index];

      if (this.dataArrayFiles.length < this.limitFiles) {
        this.dataArrayFiles.push({ file: e, inProgress: true })
        this.formArray.push(new UntypedFormControl(undefined));
      }
      else {
        console.log('Alert message');
        break;
      }
    }

    this.inputFile.nativeElement.value = "";

  }

  onClickModalShow(event: MouseEvent) {
    event.preventDefault();
    $("#" + this.modalName).modal('show');
  }

  eventAddFile(event: string, index: number) {
    // this.formArray.push(new UntypedFormControl(event));
    this.formArray.at(index).setValue(event);
    this.cd.detectChanges();
  }

  eventRemoveFile(event: string) {

    const ix = this.formArray.controls.findIndex(x => x.value === event);

    if (ix !== -1) {
      this.formArray.removeAt(ix);
      this.dataArrayFiles.splice(ix, 1)
    }
  }
}
